import Immutable from 'immutable';
import OptInConstants from '../constants/OptInConstants';

const initialState = Immutable.Map({});

const updateStateForBundle = (bundle, state, newState) =>
  state.merge({
    [bundle]: {
      ...state.get(bundle, {}),
      ...newState
    }
  });

export default function optInReducer(state = initialState, action) {
  switch (action.type) {
    case OptInConstants.TOGGLE_OPT_IN_FEEDBACK_FORM:
      return updateStateForBundle(action.bundle, state, {
        feedbackOpen: action.payload.open
      });
    case OptInConstants.OPT_IN_REQUEST:
    case OptInConstants.OPT_OUT_REQUEST:
    case OptInConstants.SUBMIT_OPT_IN_FEEDBACK_REQUEST:
      return updateStateForBundle(action.bundle, state, {
        isLoading: true
      });
    case OptInConstants.OPT_IN_SUCCESS:
    case OptInConstants.OPT_OUT_SUCCESS:
    case OptInConstants.OPT_IN_FAILURE:
    case OptInConstants.OPT_OUT_FAILURE:
      return updateStateForBundle(action.bundle, state, {
        isLoading: false
      });
    case OptInConstants.SUBMIT_OPT_IN_FEEDBACK_SUCCESS:
      return updateStateForBundle(action.bundle, state, {
        isLoading: false,
        showFeedbackSuccess: true,
        feedbackOpen: false
      });
    case OptInConstants.CLOSE_FEEDBACK_SUCCESS:
      return updateStateForBundle(action.payload, state, {
        showFeedbackSuccess: false
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/OptInReducer.js